export const skillsIsClicked = (data = {}) => {
    
    // const app = window.smetioApp;

    // app.smetioAppUi.actionBar.hideAll();
    // app.smetioAppUi.actionBar.show("cardView");

    // window.currentlyVisibleSideMenuItemName = "skills";

    // app.getTotalNumberOfAvailableData("skills");

    // app.smetioAppUi.actionBar.showAll();
    // app.smetioAppUi.actionBar.hide("listView");

    const app = window.smetioApp;
    const sideMenuToUse = "skills";
    const apiEndPoint = app.apiEndPoint;
    const language = app.language;

    app.smetioAppUi.actionBar.showAll();
    app.smetioAppUi.actionBar.hide("listView");

    app.smetioAppUi.actionBar.buttons.createNew.events["mousedown"] = async () => {

        // const createNewTeamMember = (await import(/* webpackPrefetch: true */ `./createNewTeamMember.js`)).createNewTeamMember;
        const createNewSkill = (await import(/* webpackPrefetch: true */ `./createNewSkill.js`)).createNewSkill;
        return await createNewSkill({
            apiEndPoint,
            language,
            title: "txt1331",
            accountType: app.accountType,
            urlDestination: "create"
        });
    };

    window.currentlyVisibleSideMenuItemName = sideMenuToUse;

    app.getTotalNumberOfAvailableData(sideMenuToUse);    
};
